















import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import CabinetConfiguration from '@/components/configuration/cabinet/CabinetConfiguration.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { EditMode, CabinetConfigurationModel, StoreConstants } from '@/types';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { CabinetConfigurationHelper } from '@/mixins';

export default Vue.extend({
  mixins: [CabinetConfigurationHelper],
  data() {
    return {
      newCabinetConfigurationTemplate: { id: '', isEncryptNewDocumentTypesEnabled: false } as CabinetConfigurationModel,
      isSubmitting: false,
      isLoading: true
    };
  },
  methods: {
    ...mapActions('configurationStore', ['getConfigurationTree']),
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage]),
    async getCabinetConfigurationSettingsAsync() {
      await this[StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage]();
    },
    async onSubmitAsync(this: any, cabinetConfiguration: CabinetConfigurationModel) {
      this.isSubmitting = true;
      try {
        const newCabinet = await CabinetConfigurationService.createCabinetAsync(cabinetConfiguration);
        this.setApplicationDirty(false);
        await this.getConfigurationTree();
        this.navigateToCabinetDashboard(newCabinet.id);
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    onCancel(this: any) {
      this.navigateToCabinetsDashboard();
    }
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId,
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationSettings
    ])
  },
  async mounted(this: any) {
    await this.getLock();
    this.newCabinetConfigurationTemplate.configurationChangeId = this.cabinetConfigurationChangeId;
    await Promise.all([this.getCabinetConfigurationSettingsAsync(), this.getAllCabinetNames()]);
    this.newCabinetConfigurationTemplate.isEncryptNewDocumentTypesEnabled = this.cabinetConfigurationSettings.isEncryptNewDocumentTypesEnabled;
    this.newCabinetConfigurationTemplate.isMultiValueReferencesFeatureEnabled = this.cabinetConfigurationSettings.isMultiValueReferencesFeatureEnabled;

    this.isLoading = false;
  },
  components: {
    CabinetConfiguration,
    LoadingSpinner
  },
  created(this: any) {
    this.EDIT_MODE = EditMode.Add;
  }
});
